export const multiDayAllDayFormatString = "s_eGOc";
export default {multiDayAllDayFormatString};